import React, { Component } from 'react';
import { Link } from 'react-router';
import { PRODUCT_SELECTOR } from "../../constants/app";
import { pushMenuItem } from "../../utils/datalayer";

class MobileNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuSupport: false
		};
	}

	handleLinkClick(e) {
		const target = e.currentTarget;
		const subNav = target.closest('.nav-list');
		let menuPath;
		if (subNav) {
			const parent = subNav.previousSibling;
			menuPath = `${parent.textContent} > ${target.textContent}`;
		} else {
			menuPath = `${target.textContent}`;
		}
		pushMenuItem(e, 'Header | Main Mobile', menuPath)

		this.props.toggleMobileNav();
	}

	handleClickProducts(e) {
		this.setState({
			subMenuLearn: false,
			subMenuSupport: false
		});
		let eventAction;
		if (this.state.subMenuProducts === false) {
			this.setState({ subMenuProducts: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuProducts: false });
			eventAction = 'collapse';
		}
		global.dataLayer.push({
			event: 'Mobile Header',
			eventCategory: 'Header',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickLearn(e) {
		this.setState({
			subMenuProducts: false,
			subMenuSupport: false
		});
		let eventAction;
		if (this.state.subMenuLearn === false) {
			this.setState({ subMenuLearn: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuLearn: false });
			eventAction = 'collapse';
		}
		global.dataLayer.push({
			event: 'Mobile Header',
			eventCategory: 'Header',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickSupport(e) {
		this.setState({
			subMenuProducts: false,
			subMenuLearn: false
		});
		let eventAction;
		if (this.state.subMenuSupport === false) {
			this.setState({ subMenuSupport: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuSupport: false });
			eventAction = 'collapse';
		}
		global.dataLayer.push({
			event: 'Mobile Header',
			eventCategory: 'Header',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		return (
			<nav id="mobile-nav">
				<ul>
					<li className="nav-item-products">
						<span
							className={`nav-link ${this.state.subMenuProducts ? 'active' : ''}`}
							onClick={e => this.handleClickProducts(e)}
						>
							Products
						</span>
						<ul className={`nav-list ${this.state.subMenuProducts ? 'active' : ''}`}>
							<li>
								<Link
									to="/products"
									onClick={e => this.handleLinkClick(e)}
								>
									All Products
								</Link>
							</li>
							<li>
								<a href={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET} onClick={e => this.handleLinkClick(e)}>
									{PRODUCT_SELECTOR.TEXT}
								</a>
							</li>
							<li>
								<Link
									to="/fire-waterproof-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Water and Fireproof Safes
								</Link>
							</li>
							<li>
								<Link
									to="/security-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Security Safes
								</Link>
							</li>
							<li>
								<Link
									to="/document-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Document Safes
								</Link>
							</li>
							<li>
								<Link
									to="/pistol-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Pistol Safes
								</Link>
							</li>
							<li>
								<Link
									to="/fireproof-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Fireproof Safes and Fire Bag
								</Link>
							</li>
							<li>
								<Link
									to="/cash-boxes"
									onClick={e => this.handleLinkClick(e)}
								>
									Cash Boxes
								</Link>
							</li>
							<li>
								<Link
									to="/business-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Business Safes
								</Link>
							</li>
							<li>
								<Link
									to="/portable-safes"
									onClick={e => this.handleLinkClick(e)}
								>
									Portable Safes
								</Link>
							</li>
						</ul>
					</li>
					<li className="nav-item-learn">
						<span
							className={`nav-link ${this.state.subMenuLearn ? 'active' : ''}`}
							onClick={e => this.handleClickLearn(e)}
						>
							Learn
						</span>
						<ul className={`nav-list ${this.state.subMenuLearn ? 'active' : ''}`}>
							<li>
								<Link
									to="/learn/buying-guide"
									onClick={e => this.handleLinkClick(e)}
								>
									Buying Guide
								</Link>
							</li>
							<li>
								<Link
									to="https://www.masterlock.com/insights"
									onClick={e => this.handleLinkClick(e)}
									target="_blank"
								>
									Security and Safety Insights
								</Link>
							</li>
							{/*<li>*/}
							{/*	<Link*/}
							{/*		to="/learn/fire-and-water-safes"*/}
							{/*		onClick={ e => this.handleLinkClick(e) }*/}
							{/*		data-trackEventAction="Learn"*/}
							{/*	>*/}
							{/*		Fire and Water Safes*/}
							{/*	</Link>*/}
							{/*</li>*/}
							<li>
								<Link
									to="/learn/about-us"
									onClick={e => this.handleLinkClick(e)}
								>
									About SentrySafe
								</Link>
							</li>
							<li>
								<Link
									to="/learn/customer-stories"
									onClick={e => this.handleLinkClick(e)}
								>
									Stories
								</Link>
							</li>
							<li>
								<Link
									to="/where-to-buy"
									onClick={e => this.handleLinkClick(e)}
								>
									Where To Buy
								</Link>
							</li>
						</ul>
					</li>
					<li className="nav-item-where-to-buy">
						<Link
							className="nav-link"
							to="/where-to-buy"
							onClick={e => this.handleLinkClick(e)}
						>
							Where to Buy
						</Link>
					</li>
					<li className="nav-item nav-item-buy-now-store">
						<Link
							className="nav-link"
							to="https://store.sentrysafe.com/"
							target="_blank"
							onClick={e => this.handleLinkClick(e)}
						>
							Buy Now from SentrySafe&#33;
						</Link>
					</li>
					<li className="nav-item-support">
						<span
							className={`nav-link ${this.state.subMenuSupport ? 'active' : ''}`}
							onClick={e => this.handleClickSupport(e)}
						>
							Support
						</span>
						<ul className={`nav-list ${this.state.subMenuSupport ? 'active' : ''}`}>
							<li>
								<Link
									to="/support"
									onClick={e => this.handleLinkClick(e)}
								>
									All Support
								</Link>
							</li>
							<li>
								<Link
									to="/support/find-your-model-or-serial-number"
									onClick={e => this.handleLinkClick(e)}
								>
									Find Your Model or Serial Number
								</Link>
							</li>
							<li>
								<Link
									to="/support/faqs/how-do-i-change-the-batteries-on-my-safe"
									onClick={e => this.handleLinkClick(e)}
								>
									Need Help with Your Digital Lock&#63;
								</Link>
							</li>
							<li>
								<Link
									to="/support/faqs"
									onClick={e => this.handleLinkClick(e)}
								>
									FAQs
								</Link>
							</li>
							<li>
								<Link
									to="/support/lost-key-combo"
									onClick={e => this.handleLinkClick(e)}
								>
									Lost Key or Combo
								</Link>
							</li>
							<li>
								<Link
									to="/support/videos"
									onClick={e => this.handleLinkClick(e)}
								>
									Videos
								</Link>
							</li>
							<li>
								<Link
									to="/support/product-manuals"
									onClick={e => this.handleLinkClick(e)}
								>
									Product Manuals
								</Link>
							</li>
							<li>
								<Link
									to="/support/contact-us"
									onClick={e => this.handleLinkClick(e)}
								>
									Contact Us
								</Link>
							</li>
						</ul>
					</li>

					<li className="nav-item-insights">
						<Link
							to="https://www.masterlock.com/insights"
							className="nav-link  d-flex"
							onClick={e => this.handleLinkClick(e)}
							target="_blank"
							rel="noopener"
						>
							Insights
						</Link>
					</li>

					<li className="nav-item-buy-now">
						<Link
							className="nav-link"
							to="https://store.sentrysafe.com/collections/safe-accessories?_ga=2.90638618.1080419390.1543332157-424915552.1524584795"
							onClick={e => this.handleLinkClick(e)}
							target="_blank"
							rel="noopener"
						>
							Buy Accessories
						</Link>
					</li>

					<li className="nav-item-register-my-safe">
						<Link
							className="nav-link"
							to="https://www.registermysafe.com/"
							onClick={e => this.handleLinkClick(e)}
							target="_blank"
							rel="noopener"
						>
							Register My Safe
						</Link>
					</li>
				</ul>
			</nav>
		);
	};
}

export default MobileNav;



// WEBPACK FOOTER //
// ./src/pages/components/MobileNav.js